ShellService.$inject = ['$http']

export default function ShellService($http) {
  return {
    // getUserSessionHistories: function() {
    //   return $http.get('/api/usersessionhistories')
    // },
    display: window.innerWidth <= 767 ? 'small' : window.innerWidth > 767 && window.innerWidth <= 1199 ? 'medium' : 'large'
  }
}